import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DatabaseConnection } from '../services/database-connection';
import { ToastrService } from '../services/toastr-service';

export const offlineGuard: CanActivateFn = (route, state) => {
  const connect = inject(DatabaseConnection)
  const router = inject(Router)
  const toastr = inject(ToastrService)

  if(!connect.connection.value){
    toastr.war("Menu bloquée car vous etez en mode local.")
    router.navigateByUrl("/home")
    return false
  }

  return true;
};
